// ESlint complains about prop-types, you need to define it
import PropTypes from 'prop-types';
Blurb.propTypes = {
  handleModal: PropTypes.func.isRequired,
};

// this are the details for this attestation field
export function Config() {
  return {
    name: 'txDefensiveDrivingRush', // this used as the field name as well as the unique identifier
    productIds: [
      // '8bd12654-1dbc-4f55-e555-08dbbf5f0502', // Texas Defensive Driving - CERTUS_UNIVERSITY_3060
    ],
    errorMsg: `The Student must accept the <strong>Texas Driver Safety enrollment contract</strong> by checking the box.`,
    onlyForBulk: false, // set to true if this attestation is only for bulk purchase
    type: 'checkbox', // iAgree, signature, checkbox
  };
}

// this is the blurb we display to tell the user what this attestation field is for
export function Blurb() {
  return (
    <>
      By checking this box, the Student accepts the{' '}
      <a
        href="https://cdn.certus.com/global/pdf/tx-dd-enrollment-contract-rush.pdf"
        target="_blank"
        rel="noopener nofollow noreferrer"
      >
        Texas Driver Safety enrollment contract
      </a>
      .
    </>
  );
}

// this is the explaination of the attestation, the full details of what the user is aggreeing to
export function ModalContent() {
  return null;
}
